import React from 'react';

export const TrueIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            version="1.1"
            viewBox="0 0 5.821 5.821"
        >
            <g fill="#fff" fillOpacity="1">
                <path strokeWidth="0.529" d="M0 2.646H4.762V3.175H0z"></path>
                <path
                    stroke="none"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeOpacity="1"
                    strokeWidth="0.265"
                    d="M4.233 1.852L5.821 2.91 4.233 3.97z"
                ></path>
                <path
                    stroke="none"
                    strokeWidth="2"
                    d="M11 3C9.338 3 8 4.338 8 6v10c0 1.662 1.338 3 3 3h2.3c1.309 0 2.407-.835 2.818-2H11c-.554 0-1-.446-1-1V6c0-.554.446-1 1-1h5.118A2.985 2.985 0 0013.3 3z"
                    transform="scale(.26458)"
                ></path>
                <path
                    stroke="none"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeOpacity="1"
                    strokeWidth="0.265"
                    d="M3.44.265l1.323.793-1.323.794z"
                ></path>
                <path
                    stroke="none"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeOpacity="1"
                    strokeWidth="0.265"
                    d="M3.44 3.969l1.323.794-1.323.793z"
                ></path>
            </g>
        </svg>
    );
};
